import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: '', // require('@/assets/img/sidebar-1.jpg'),
    drawer: null,
    jwtToken: '',
    user: {},
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload
    },
    LOGIN (state, payload) {
      state.jwtToken = payload.jwtToken
      state.user = payload.user
      window.localStorage.setItem('jwtToken', payload.jwtToken)
      window.localStorage.setItem('user', JSON.stringify(payload.user))
    },
    LOGOUT (state, payload) {
      state.user = null
      state.jwtToken = ''
      window.localStorage.setItem('jwtToken', '')
      window.localStorage.setItem('user', null)
    },
  },
  actions: {

  },
  getters: {
    isLoggedIn: state => {
      var jwtToken = window.localStorage.getItem('jwtToken')
      return !!jwtToken
    },
    // authStatus: state => state.status,
  },
})
